import React from 'react'

export default () =>
{
    document.body.style.backgroundColor = "white";
    var header = document.getElementsByClassName("header")[0];
    if (header)
        header.setAttribute("style", "display:none;");
    return (
        <div>
            <div className="container text-center">
                <div className="row justify-content-md-center">
                    <div className="col-md-auto">
                        <h3>Order not found</h3>
                    </div>
                </div>
            </div>
        </div>
    )
}
